import {Component} from '@angular/core';
import {WaDividerDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-cap-spi',
	templateUrl:'./SpiExtensibilityPage.html',
	styles: [],
	styleUrls:['./SpiExtensibilityPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaDividerDirective,
		WaTextDirective,
		MarkdownComponent,
],
	standalone:true
})
export class SpiExtensibilityPage
{
	mdContent_27 = `\`\`\`java
public class AnalyticsConfigurator
        implements IPageConfigurator<AnalyticsConfigurator> {

    @Override
    public IPage<?> configure(IPage<?> page) {
        page.addJavaScriptReference(
            new JavascriptReference("analytics", 1.0, "analytics.js"));
        return page;
    }

    @Override
    public Integer sortOrder() { return 500; }
}
\`\`\``;
	mdContent_28 = `\`\`\`java
provides IPageConfigurator with AnalyticsConfigurator;
\`\`\``;
}
